import { lazyRoute } from "@/routes/lazy-route";

const PublicDashboardDefault = lazyRoute(() => import("@/domain/public-dashboard/routes/public-dashboard-embed.page"), "PublicDashboardDefault");
const PublicDashboardProject = lazyRoute(() => import("@/domain/public-dashboard/routes/public-dashboard-embed.page"), "PublicDashboardProject");
const PublicDashboardClimateAction = lazyRoute(() => import("@/domain/public-dashboard/routes/public-dashboard-embed.page"), "PublicDashboardClimateAction");

export const publicEmbedRoutes = [
  {
    path: "/embed/dashboard/:dashboardId",
    element: <PublicDashboardDefault />,
  },
  {
    path: "/embed/project/:projectId",
    element: <PublicDashboardProject />,
  },
  {
    path: "/embed/climate-action/:climateActionId",
    element: <PublicDashboardClimateAction />,
  },
];
